import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-language-select',
  imports: [CommonModule, SelectModule, FormsModule],
  templateUrl: './language-select.component.html',
  styleUrl: './language-select.component.scss',
  standalone: true,
})
export class LanguageSelectComponent {
  dataSource = [
    {flag:'gb.svg', code: 'en', name: 'English' },
    {flag:'cn.svg',  code: 'zh', name: '中文' },
    {flag:'my.svg',  code: 'ms', name: 'Bahasa Melayu' },
    {flag:'in.svg',  code: 'ta', name: 'தமிழ்' },
    {flag:'fr.svg',  code: 'fr', name: 'Français' },
    {flag:'de.svg',  code: 'de', name: 'Deutsch' },
    {flag:'es.svg',  code: 'es', name: 'Español' },
  ];
  
  selectedItem:any;
}
